import React from 'react';
import { connect } from 'react-redux';
import { setCache } from '../../General/Actions.js';
import { setUserDetails, setSwitchAccountModalFalse, setSwitchAccountModalTrue } from '../../General/Actions.js';
import { BrowserRouter as Router, Route, Link, NavLink, Switch } from "react-router-dom";
import { Navbar, NavbarBrand, Nav, NavItem} from 'reactstrap';

import redBanner from '../../ImageAssets/redBanner.png';
import avatar from '../../ImageAssets/avatarsquare.png';
import ApuaWhiteTextLogo from '../../ImageAssets/Apua_New_Logo_White.png';
import hamMenu from "../../ImageAssets/hamMenu.png";

import BundlesComponent from './BundlesComponent'
import HomeComponent from './HomeComponent.js';
import RechargeComponent from './RechargeComponent.js'
import InvoicesComponent from './InvoicesComponent.js'
import ChangePlanComponent from './ChangePlanComponent.js'
import RewardsPageComponent from './RewardsPageComponent.js'
import AccountSettingComponent from './AccountSettingsComponent.js'
import HistoryPageComponent from './HistoryPageComponent.js'
import FriendsAndFamilyComponent from './FriendsAndFamilyComponent.js'
import ServiceCenterComponent from './ServiceCenterComponent.js';
import Network from '../../Utils/network.js';
import Swal from 'sweetalert2';
import PortalLoadingScreen from './portalLoadingScreen';
import SelectAllServiceComponent from './SelectAllServiceComponent'

class PortalPageNewComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            billingName: "NA",
            contactNumber: "NA",
            isLoading: true,
            isAccountSelectionPageVisible: false,
            currentPage: "",
            dropdownOpen: false,
            allAccountList: [],
            billsAndPaymentStatus: 1,
            myOrderStatus: 1,
            settingsStatus: 1,
            serviceCenterStatus: 1,
            isToggleClicked: false,
            sticky: false,
            phoneNumber: "0",
            hideBillsAndPaymentForPrepaid: false,
            isMobile: false,
            showMobileMenu: false,
            connectionType: "",
            isServiceSelectionPageVisible: false
        };
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
        if (window.performance.navigation.type === window.performance.navigation.TYPE_RELOAD) {
            // Redirect to the home page
            window.location.replace('/'); // Replace with the URL of your home page
            }
    
        Network.executeAxios("querySubscriber", "POST", {}, (querySubscriberResponse) => {
            this.props.setCache("querySubscriberResponse", querySubscriberResponse);
            Network.executeAxios("fetchServiceInfo", "POST", {}, (fetchServiceInfoResponse) => {
                var serviceListResponse = [];
                try {
                    serviceListResponse = fetchServiceInfoResponse.BillingSystem.response.dataset.service_info;
                } catch (err) {
                    serviceListResponse = [];
                }

                this.props.setCache("serviceListResponse", serviceListResponse);

            
                if(serviceListResponse && serviceListResponse.length > 1){
                        var currentAccountInLocalStorage = localStorage.getItem("currentService");
                        if (currentAccountInLocalStorage != null) {
                            this.props.setUserDetails("currentService", currentAccountInLocalStorage);
                            this.initializeService(currentAccountInLocalStorage);
                        } else {
                            this.setState({isServiceSelectionPageVisible: true})
                        }
                   
                }  if(serviceListResponse && serviceListResponse.length == 1){
                        this.initializeService(serviceListResponse[0].service_id);
                } 

            Network.executeAxios("fetchAccountDetails", "POST", {}, (fetchAccountDetailsResponse) => {
                this.props.setCache("fetchAccountDetailsResponse", fetchAccountDetailsResponse);
                this.initializePortalRoot(querySubscriberResponse);
            });
        })

        })
    }

    initializeService = (receivedId) => {
        var serviceId = ""; 
        var connectionType = "";
        var accountId = "";
        var networkType= "";
        var serviceName = "";
        var serviceTypeId = "";
        var serviceListResponse = this.props.cache.serviceListResponse.filter(obj => obj.service_id === receivedId)
        if(serviceListResponse && serviceListResponse[0]){
            serviceId = serviceListResponse[0].service_id;
            connectionType = serviceListResponse[0].connection_type;
            accountId = serviceListResponse[0].account_id;
            networkType = serviceListResponse[0].network_type;
            serviceName = serviceListResponse[0].service_name;
            serviceTypeId = serviceListResponse[0].service_type_id;
        }

        
    let temp = {
        "serviceId": serviceId,
        "serviceTypeId": serviceTypeId,
        "connectionType": connectionType,
        "accountId": accountId,
        "networkType": networkType,
        "serviceName": serviceName
    }

    this.props.setUserDetails("currentAccount", accountId);
    localStorage.setItem("currentAccount", accountId);

    var allPogIds = [];
    if (this.props.configurationValues) {
        allPogIds = this.props.configurationValues.allPog
    }

    if (Array.isArray(allPogIds)) {
        for (var y = 0; y < allPogIds.length; y++) {
            for (var z = 0; z < serviceListResponse.length; z++) {
                if (connectionType === this.props.locales.connectionTypeForPrepaid) {
                    if (allPogIds[y].name.toUpperCase() === "GSMPREPAID") {
                        temp["pog"] = allPogIds[y].id;
                    }
                } else if (connectionType === this.props.locales.connectionTypeForPrepaidPlus) {
                    if (allPogIds[y].name.toUpperCase() === "PREPAIDPLUS") {
                        temp["pog"] = allPogIds[y].id;
                    }
                } else if (connectionType === this.props.locales.connectionTypeForPostpaid) {
                    if (allPogIds[y].name.toUpperCase() === allPogIds[y].name) {
                        temp["pog"] = allPogIds[y].id;
                    }
                } else {
                    temp["pog"] = "0"
                }
            }
        }
    }
    //this.props.setCache("serviceInfo",temp)
    this.props.setCache("serviceListResponse",serviceListResponse)
    this.props.setCache("serviceInfo",temp)
    this.setState({connectionType: connectionType, isServiceSelectionPageVisible: false, isLoading: false})
    }

    initializePortalRoot(receivedResponse) {
        var params = [];
        try {
            params = receivedResponse.profile_info.basic_details;
        } catch (err) {
            params = [];
        }
        var finalBillingName = "";
        var finalContactNumber = "";
        var customerType = ""
        var customerCategory = "";
        var customerSubCategory = "";
        var lastName = "";
        for (var i = 0; i < params.length; i++) {
            if (params[i].id === "first_name") {
                finalBillingName = params[i].value;
            }
            if (params[i].id === "last_name") {
                lastName = params[i].value;
            }
            if (params[i].id === "contact_number_1") {
                finalContactNumber = params[i].value;
            }
            if (params[i].id === "subscriber_category") {
                customerCategory = params[i].value;
            }
            if (params[i].id === "subscriber_sub_category") {
                customerSubCategory = params[i].value;
            }
            if (params[i].id === "profile_type") {
                customerType = params[i].value;
            }
        }
        this.props.setUserDetails("billingName", finalBillingName + " " + lastName);
        this.props.setUserDetails("customerCategory", customerCategory);
        this.props.setUserDetails("customerSubCategory", customerSubCategory);
        this.props.setUserDetails("customerType", customerType);
    
        this.setState({
            billingName: finalBillingName + " " + lastName,
            contactNumber: finalContactNumber,
            customerCategory: customerCategory,
            customerSubCategory: customerSubCategory
        },() => {
            this.getAccessPrivilages();
            console.log(this.state.billingName)
        });


    }

    getAccessPrivilages() {
        var dataToSend = {
            customerCategory: this.state.customerCategory,
            customerSubCategory: this.state.customerSubCategory
        }
        Network.executeAxios("fetchAccessPrivilages", "POST", dataToSend, (accessPrivilagesResponse) => {
            if (accessPrivilagesResponse.STATUS === "SUCCESS") {
                this.initializeFeatures(accessPrivilagesResponse);
            } else {
                console.log("No Restrictions found for this profile");
                setTimeout(() => {
                    this.setState({ isLoading: false });
                }, 1000);
            }
        });
    }

    initializeFeatures(response) {
        var featureArray = response.FEATURES;
        var finalFeatures = [];
        for (var i = 0; i < featureArray.length; i++) {
            var temp = {
                featureName: featureArray[i].FEATURE_NAME,
                status: featureArray[i].STATUS
            }
            finalFeatures.push(temp);
        }
        this.props.setUserDetails("features", finalFeatures);
        this.manageFeatures();
    }

    manageFeatures() {        // 1-show feature   0-hide feature
        var billsAndPaymentStatus = 1;
        var myOrderStatus = 1;
        var settingsStatus = 1;
        var serviceCenterStatus = 1;
        var features = this.props.userDetails.features;
        if (features.length > 0) {
            for (var i = 0; i < features.length; i++) {
                if (features[i].featureName === "ViewBillsAndPayments") {
                    billsAndPaymentStatus = features[i].status;
                } else if (features[i].featureName === "ViewMyOrders") {
                    myOrderStatus = features[i].status;
                } else if (features[i].featureName === "Settings") {
                    settingsStatus = features[i].status;
                } else if (features[i].featureName === "ViewServiceCenter") {
                    serviceCenterStatus = features[i].status;
                }
            }
        }
        this.setState({
            billsAndPaymentStatus: billsAndPaymentStatus,
            settingsStatus: settingsStatus,
            serviceCenterStatus: serviceCenterStatus,
            isLoading: false
        })
    }

    navLinkClicked(type) {
        setTimeout(() => {
            this.setState({
                currentPage: type,
                isToggleClicked: false,
                isOpen: false
            });
        }, 500);
        document.body.classList.remove('modal-open');
    }

    optionsButtonClicked(type, needConfirmation) {
        if (type === "logout") {
            if (needConfirmation) {
                Swal.fire({
                    title: this.props.locales.logoutConfirmationTitleInSwal,
                    text: "",
                    type: '',
                    showCancelButton: true,
                    confirmButtonText: this.props.locales.okButtonTextInSwal,
                    cancelButtonText: this.props.locales.cancelButtonTextInSwal,
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) { this.optionsButtonClicked("logout"); }
                });
            } else {
                Network.executeAxios("logout", "GET", {}, (response) => {
                    if (response.STATUS === "SUCCESS") {
                        localStorage.removeItem("isUserLoggedIn");
                        localStorage.removeItem("uniqueToken");
                        localStorage.removeItem("currentAccount");
                        localStorage.removeItem("currentService");
                        localStorage.removeItem("isSignInOptionClickedForMobile");
                        if (localStorage.getItem("isMobile")) {
                            localStorage.setItem("isSignInOptionClickedForMobile", true)
                            window.location.replace('/mobile=true&mobileNumber=' + this.state.phoneNumber);
                        } else {
                            localStorage.removeItem("isMobile");
                            window.location.replace('/');
                        }

                    } else {
                        Swal.fire(this.props.locales.logoutFailedTitleInSwal, "", "");
                    }
                });
            }
        } else if (type === "switchAccount") {
            this.props.setSwitchAccountModalTrue();
        }
    }


    updateWindowDimensions = () => {
        this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
        if(window.innerWidth <= 767)
        this.setState({isMobile: true})
        else 
        this.setState({isMobile: false})
    }

    userSelectServiceForSwitchService = (receivedId) => {
        this.setState({
            isServiceSelectionPageVisible: false,
            isLoading: true
        });
        this.props.setSwitchAccountModalFalse();
        this.props.setUserDetails("currentService", receivedId);
        localStorage.setItem("currentService", receivedId);
        this.initializeService(receivedId);

    }

    initialize = (receivedId) => {
        Network.executeAxios("querySubscriber", "POST", {}, (querySubscriberResponse) => {
            this.props.setCache("querySubscriberResponse", querySubscriberResponse);
            Network.executeAxios("fetchServiceInfo", "POST", {}, (fetchServiceInfoResponse) => {
                var serviceListResponse = [];
                try {
                    serviceListResponse = fetchServiceInfoResponse.BillingSystem.response.dataset.service_info;
                } catch (err) {
                    serviceListResponse = [];
                }
                this.props.setCache("serviceListResponse", serviceListResponse);

                if (serviceListResponse.length == 1) {
                    if (serviceListResponse[0].connection_type !== "1") {
                        this.setState({ hideBillsAndPaymentForPrepaid: true })
                    }
                }

                Network.executeAxios("fetchAccountDetails", "POST", {}, (fetchAccountDetailsResponse) => {
                    this.props.setCache("fetchAccountDetailsResponse", fetchAccountDetailsResponse);
                    this.initializePortalRoot(querySubscriberResponse);
                });
            });
        });
    }

    render() {
         if (this.state.isLoading == true) {
            return (<PortalLoadingScreen />);
        } else if (this.state.isServiceSelectionPageVisible) {
            const portalOuterMainContainerStyle = { height: this.state.windowHeight + 'px' };
            return (
                <div className="d-flex flex-column animated fadeIn" style={portalOuterMainContainerStyle}>
                    <SelectAllServiceComponent reInitialize={this.userSelectServiceForSwitchService} />
                </div>
            );
         } else {
            return (this.componentContent());
         }
        // if (this.state.isLoading == true) {
        //     return (<PortalLoadingScreen />);
        // } else {
        //     return (this.componentContent());
        // }
    }

    componentContent() {
        return (
            <div id="portalOuterMainContainer" className="col-md-12 p-0 m-0 animated fadeIn" style={{height: this.state.windowHeight + 'px'}}>
                <div id="sessionOutDiv"></div>
                <Router style={{}}>
                    <div style={{height: this.state.windowHeight + 'px'}}>
                        <div className='' style={{}}>
                            {/* <img alt="" src={redBanner} width={"100%"} height={(this.state.windowHeight/100)*30+"px"}/> */}
                            {/* <div className='px-4' style={{position:"absolute", top:0, width:window.innerWidth, backgroundImage: `url(${redBanner})`,}}> */}
                            {!this.state.isMobile ?(
                            <div className='p-5' style={{  backgroundImage: `url(${redBanner})`,backgroundRepeat:"no-repeat",backgroundSize:"100% 100%",}}>
                                <div className='d-flex justify-content-between' style={{}}>
                                    <div className="" style={{ cursor: 'pointer' }} onClick={() => { this.navBarClicked() }} >
                                        <div className="col-md-6"><img alt="" src={ApuaWhiteTextLogo} /></div>
                                    </div>
                                    <div className="d-flex align-items-center pl-lg-5 pl-md-3">
                                        <div className="pr-3" style={{ color: '#FFFFFF', fontWeight: 700, fontSize: 20 }}><span style={{fontWeight: 300}}>Welcome, </span>{this.state.billingName}</div>
                                        <img src={avatar} alt="" className="" width="40" height="40" />
                                        <div className="pl-3" style={{ color: '#FFFFFF', fontWeight: "normal", fontSize: 14, cursor: 'pointer'}} onClick={() => { this.optionsButtonClicked("logout", true) }}>Logout</div>
                                    </div>
                                </div>
                                <div id="navbarPart" className="d-flex justify-content-end pb-5"> 
                                    <NavItem className="d-flex align-items-center p-2" style={{}}>
                                        <NavLink exact to="/" activeClassName="activeMenu px-3" onClick={() => { this.navLinkClicked('');}}>Home</NavLink>
                                    </NavItem>
                                    {this.state.connectionType != "1" ?
                                    <NavItem className="d-flex align-items-center p-2 pl-lg-3 pl-md-2" style={{}}>
                                        <NavLink to="/Recharge" activeClassName="activeMenu px-3" onClick={() => { this.navLinkClicked('Recharge') }}>Recharge</NavLink>
                                    </NavItem>
                                    : null }

                                    {this.state.connectionType == "1" ?
                                    <NavItem className="d-flex align-items-center p-2 pl-lg-3 pl-md-2" style={{}}>
                                        <NavLink to="/Invoices" activeClassName="activeMenu px-3" onClick={() => { this.navLinkClicked('Invoices') }}>Invoices</NavLink>
                                    </NavItem>
                                    : null }

                                    <NavItem className="d-flex align-items-center p-2 pl-lg-3 pl-md-2">
                                        <NavLink to="/Bundles" activeClassName="activeMenu px-3" onClick={() => { this.navLinkClicked('Bundles') }}>Bundles</NavLink>
                                    </NavItem>
                                    {this.state.connectionType == "1" ? null :
                                    <NavItem className="d-flex align-items-center p-2 pl-lg-3 pl-md-2">
                                        <NavLink to="/ChangePlan" activeClassName="activeMenu px-3" onClick={() => { this.navLinkClicked('Change Plan'); this.setState({showMobileMenu: !this.state.showMobileMenu}); }}>Change Plan</NavLink>
                                    </NavItem>
                                    }
                                    <NavItem className="d-flex align-items-center p-2 pl-lg-3 pl-md-3">
                                        <NavLink to="/Rewards" activeClassName="activeMenu px-3" onClick={() => { this.navLinkClicked('Rewards') }}>Rewards</NavLink>
                                    </NavItem>

                                    {this.props.registerDetails.isFnFAdded === "true" ?
                                    <NavItem className="d-flex align-items-center p-2 pl-lg-3 pl-md-3">
                                        <NavLink to="/FNF" activeClassName="activeMenu px-3" onClick={() => { this.navLinkClicked('FNF') }}>FNF</NavLink>
                                    </NavItem>
                                    : null }
                                    <NavItem className="d-flex align-items-center p-2 pl-lg-3 pl-md-3">
                                        <NavLink to="/AccountSettings" activeClassName="activeMenu px-3" onClick={() => { this.navLinkClicked('Account Settings') }}>Account Settings</NavLink>
                                    </NavItem>
                                    <NavItem className="d-flex align-items-center p-2 pl-lg-3 pl-md-3">
                                        <NavLink to="/History" activeClassName="activeMenu px-3" onClick={() => { this.navLinkClicked('History') }}>History</NavLink>
                                    </NavItem>
                                    <NavItem className="d-flex align-items-center p-2 pl-lg-3 pl-md-3">
                                        <NavLink to="/CustomerSupport" activeClassName="activeMenu px-3" onClick={() => { this.navLinkClicked('Customer Support') }}>Customer Support</NavLink>
                                    </NavItem>
                                </div>
                                <div className='p-3' ></div>
                            </div>):(<div className='' style={{  backgroundImage: `url(${redBanner})`,backgroundRepeat:"no-repeat",backgroundSize:"100% 100%"}}>
                                <div className='d-flex justify-content-between align-items-center px-4 py-3'>
                                    <div className="col-md-6"><img alt="" src={ApuaWhiteTextLogo} /></div>
                                    <div style={{}} onClick={() => { this.setState({showMobileMenu: !this.state.showMobileMenu}) }} >
                                        <img src={hamMenu} alt="" width="40" />
                                    </div>
                                </div>
                                <div className='p-5'></div>
                            </div>)}

                            {this.state.isMobile && this.state.showMobileMenu ? (
                            <div className='d-flex p-0 fadeInLeft' style={{ position:"fixed",top:0,right:0, width:"100%", height:"100%", zIndex:100}}> 
                               
                                <div id="navbarPart" className="p-5 navBarMobStyle" style={{width:"70%"}}> 
                                    <div className="d-flex align-items-center pl-lg-5 pl-md-3 mb-5">
                                        <img src={avatar} alt="" className="" width="40" height="40" />
                                        <div className="pl-3" style={{ color: '#FFFFFF', fontWeight: 700, fontSize: 20 }}><div style={{fontWeight: 300}}>Welcome, </div>{this.state.billingName}</div>
                                    </div>
                                    <NavItem className="d-flex align-items-center p-2" style={{}}>
                                        <NavLink exact to="/" activeClassName="activeMenu px-3" onClick={() => { this.navLinkClicked(''); this.setState({showMobileMenu: !this.state.showMobileMenu}); }}>Home</NavLink>
                                    </NavItem>
                                    {this.state.connectionType != "1" ?
                                    <NavItem className="d-flex align-items-center p-2 pl-lg-3 pl-md-2" style={{}}>
                                        <NavLink to="/Recharge" activeClassName="activeMenu px-3" onClick={() => { this.navLinkClicked('Recharge'); this.setState({showMobileMenu: !this.state.showMobileMenu}); }}>Recharge</NavLink>
                                    </NavItem>
                                    : null }

                                    {this.state.connectionType == "1" ?
                                    <NavItem className="d-flex align-items-center p-2 pl-lg-3 pl-md-2" style={{}}>
                                        <NavLink to="/Invoices" activeClassName="activeMenu px-3" onClick={() => { this.navLinkClicked('Invoices'); this.setState({showMobileMenu: !this.state.showMobileMenu}); }}>Invoices</NavLink>
                                    </NavItem>
                                    : null }

                                    <NavItem className="d-flex align-items-center p-2 pl-lg-3 pl-md-2">
                                        <NavLink to="/Bundles" activeClassName="activeMenu px-3" onClick={() => { this.navLinkClicked('Bundles');this.setState({showMobileMenu: !this.state.showMobileMenu}); }}>Bundles</NavLink>
                                    </NavItem>

                                    {this.state.connectionType == "1" ? null :
                                    <NavItem className="d-flex align-items-center p-2 pl-lg-3 pl-md-2">
                                        <NavLink to="/ChangePlan" activeClassName="activeMenu px-3" onClick={() => { this.navLinkClicked('Change Plan'); this.setState({showMobileMenu: !this.state.showMobileMenu}); }}>Change Plan</NavLink>
                                    </NavItem>
                                    }
                                    <NavItem className="d-flex align-items-center p-2 pl-lg-3 pl-md-3">
                                        <NavLink to="/Rewards" activeClassName="activeMenu px-3" onClick={() => { this.navLinkClicked('Rewards'); this.setState({showMobileMenu: !this.state.showMobileMenu}); }}>Rewards</NavLink>
                                    </NavItem>
                                    {this.props.registerDetails.isFnFAdded === "true" ?
                                    <NavItem className="d-flex align-items-center p-2 pl-lg-3 pl-md-3">
                                        <NavLink to="/FNF" activeClassName="activeMenu px-3" onClick={() => { this.navLinkClicked('FNF'); this.setState({showMobileMenu: !this.state.showMobileMenu}); }}>FNF</NavLink>
                                    </NavItem>
                                    : null }
                                    <NavItem className="d-flex align-items-center p-2 pl-lg-3 pl-md-3">
                                        <NavLink to="/AccountSettings" activeClassName="activeMenu px-3" onClick={() => { this.navLinkClicked('Account Settings'); this.setState({showMobileMenu: !this.state.showMobileMenu}); }}>Account Settings</NavLink>
                                    </NavItem>
                                    <NavItem className="d-flex align-items-center p-2 pl-lg-3 pl-md-3">
                                        <NavLink to="/History" activeClassName="activeMenu px-3" onClick={() => { this.navLinkClicked('History'); this.setState({showMobileMenu: !this.state.showMobileMenu}); }}>History</NavLink>
                                    </NavItem>
                                    <NavItem className="d-flex align-items-center p-2 pl-lg-3 pl-md-3">
                                        <NavLink to="/CustomerSupport" activeClassName="activeMenu px-3" onClick={() => { this.navLinkClicked('Customer Support'); this.setState({showMobileMenu: !this.state.showMobileMenu}); }}>Customer Support</NavLink>
                                    </NavItem>
                                    <div className="pl-2" style={{ color: '#FFFFFF', fontWeight: "normal", fontSize: 14, cursor: 'pointer'}} onClick={() => { this.optionsButtonClicked("logout", true) }}>Logout</div>

                                </div>

                                <div style={{backgroundColor:"#00000080", width:"30%"}} onClick={() => { this.setState({showMobileMenu: !this.state.showMobileMenu}) }}>
                            </div>
                            
                            </div>
                            ) : null}
                        </div>
                        <Switch style={{}}>
                            <div className='routeContainer' style={{marginTop:-10,marginLeft: 'auto', marginRight: 'auto',minHeight: (this.state.windowHeight/100)*70 + 'px'}}>
                                <Route exact path="/" component={HomeComponent} />
                                <Route exact path="/Recharge" component={RechargeComponent} />
                                <Route exact path="/Invoices" component={InvoicesComponent} />
                                <Route exact path="/Bundles" component={BundlesComponent} />
                                <Route exact path="/ChangePlan" component={ChangePlanComponent} />
                                <Route exact path="/Rewards" component={RewardsPageComponent} />
                                <Route exact path="/FNF" component={FriendsAndFamilyComponent} />
                                <Route exact path="/AccountSettings" component={AccountSettingComponent} />
                                <Route exact path="/History" component={HistoryPageComponent} />
                                <Route exact path="/CustomerSupport" component={ServiceCenterComponent} />
                            </div>
                           
                        </Switch>
                        <div className="footer-part row m-0 mt-2 text-center justify-content-center align-content-center">
                            Copyright 2024 APUA INET
                        </div>
                       
                    </div>
                   
                </Router> 
            </div>
        )
    }
}

const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales,
        cache: state.cache,
        userDetails: state.userDetails,
        isSwitchAccountModalVisible: state.isSwitchAccountModalVisible,
        contextParameters: state.contextParameters,
        configurationValues: state.configurationValues,
        registerDetails: state.registerDetails
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setCache: function (key, payload) {
            dispatch(setCache(key, payload));
        },
        setUserDetails: function (key, payload) {
            dispatch(setUserDetails(key, payload));
        },
        setSwitchAccountModalTrue: function () {
            dispatch(setSwitchAccountModalTrue());
        },
        setSwitchAccountModalFalse: function () {
            dispatch(setSwitchAccountModalFalse());
        }
    }
}

const PortalPageRootComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(PortalPageNewComponent)


export default PortalPageRootComponentContainer;